import Icon from '@/components/ui/AppIcon';

interface FooterLink {
  id: string;
  label: string;
  href: string;
}

const footerLinks: FooterLink[] = [
  { id: 'footer_prices', label: 'Preise', href: '#preise' },
  { id: 'footer_security', label: 'Sicherheit', href: '#sicherheit' },
  { id: 'footer_contact', label: 'Kontakt', href: '#kontakt' },
  { id: 'footer_login', label: 'Login', href: '#login' },
];

const socialLinks = [
  { id: 'social_linkedin', icon: 'ShareIcon', href: '#', label: 'LinkedIn' },
  { id: 'social_twitter', icon: 'ShareIcon', href: '#', label: 'Twitter' },
];

export default function FooterSection() {
  return (
    <footer className="bg-white border-t border-slate-200 py-12">
      <div className="max-w-7xl mx-auto px-6">
        {/* Single Row Footer (Pattern 1) */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
              <Icon name="ShieldCheckIcon" size={20} variant="solid" className="text-primary-foreground" />
            </div>
            <span className="font-serif text-xl tracking-tight text-foreground font-medium">
              2FA-Killer
            </span>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm font-medium text-muted-foreground">
            {footerLinks.map((link) => (
              <a
                key={link.id}
                href={link.href}
                className="hover:text-foreground transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.id}
                href={social.href}
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label={social.label}
              >
                <Icon name={social.icon as any} size={20} variant="outline" className="text-muted-foreground hover:text-primary" />
              </a>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-slate-100 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <p>© 2026 2FA-Killer. Alle Rechte vorbehalten.</p>
          <div className="flex gap-6">
            <a href="#datenschutz" className="hover:text-foreground transition-colors">
              Datenschutz
            </a>
            <a href="#agb" className="hover:text-foreground transition-colors">
              AGB
            </a>
            <a href="#impressum" className="hover:text-foreground transition-colors">
              Impressum
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}